import { ProductCategoryMap, SubCategoriesMap } from "../../constants/inventory-category"

export const GetProductCategories = (productCategories, { withDiscount = false }) => {
    let categories = []
    productCategories.forEach((category) => {
        if (withDiscount && ProductCategoryMap[category['cid']]) {
            if (category.md) categories.push({ ...category, ...ProductCategoryMap[category['cid']] })
        } else if (category?.pc && category.pc > 0 && ProductCategoryMap[category['cid']])
            categories.push({ ...category, ...ProductCategoryMap[category['cid']] })
    })
    if (withDiscount) categories.sort((a, b) => { return b.md - a.md })
    else categories.sort((a, b) => { return b.pc - a.pc || a.name.localeCompare(b.name) })
    return categories
}

export const GetProductSubCategories = (productCategories, { selectedCategory: category }) => {
    if (!category) return []
    let _categoryList = []
    let subCategories = SubCategoriesMap[category.cid]
    if (!subCategories) return []
    subCategories.forEach(subCategory => {
        productCategories.forEach(productCategory => {
            if (productCategory.cid == subCategory.cid &&
                productCategory?.pc && productCategory.pc > 0)
                _categoryList.push({
                    ...productCategory,
                    ...subCategory
                })
        })
    })
    _categoryList.sort((a, b) => { return b.pc - a.pc || a.name.localeCompare(b.name) })
    return _categoryList
}
